module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ab1aa02438c4970ec7010ef055a6695c.png";